/**
 * Arcanist — shared cross-page interactions.
 * Ported from assets/js/main.js (PHP).
 *
 * Horizon desktop (≥990px) scrolls `.page-wrapper`, not window — Lenis +
 * ScrollTrigger must use the same scroller (see base.css + scroll-container.js).
 */
if (window.gsap && window.ScrollTrigger) {
  gsap.registerPlugin(ScrollTrigger);
}

var ARCANIST_SCROLL_BREAKPOINT = 990;
var PAGE_WRAPPER_SELECTOR = ".page-wrapper";

function getArcanistScrollContainer() {
  if (window.matchMedia("(min-width: " + ARCANIST_SCROLL_BREAKPOINT + "px)").matches) {
    return document.querySelector(PAGE_WRAPPER_SELECTOR);
  }
  return null;
}

function getArcanistScroller() {
  return getArcanistScrollContainer() || window;
}

function getArcanistScrollTop() {
  var container = getArcanistScrollContainer();
  if (container) return container.scrollTop;
  return window.scrollY || document.documentElement.scrollTop || 0;
}

window.ArcanistScroll = {
  getContainer: getArcanistScrollContainer,
  getScroller: getArcanistScroller,
  getScrollTop: getArcanistScrollTop,
};

document.addEventListener("DOMContentLoaded", () => {
  setupSmoothScroll();
  setupMobileNav();
  setupHeadroom();
});

function setupHeadroom() {
  const header = document.getElementById("site-header");
  if (!header || typeof Headroom === "undefined") return;

  let headroom = null;

  function initOrDestroyHeadroom() {
    const isDesktop = window.innerWidth > 768;

    if (isDesktop) {
      if (!headroom) {
        headroom = new Headroom(header, {
          offset: 70,
          tolerance: { up: 10, down: 5 },
          classes: {
            initial: "headroom-header",
            pinned: "headroom-header--pinned",
            unpinned: "headroom-header--unpinned",
            top: "headroom-header--top",
            notTop: "headroom-header--not-top",
          },
        });
        headroom.init();
      }
    } else if (headroom) {
      headroom.destroy();
      headroom = null;
      header.classList.remove(
        "headroom-header",
        "headroom-header--pinned",
        "headroom-header--unpinned",
        "headroom-header--top",
        "headroom-header--not-top"
      );
    }
  }

  initOrDestroyHeadroom();
  window.addEventListener("resize", initOrDestroyHeadroom);
}

window.addEventListener("load", () => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  setupFooterCardRotation(reduceMotion);
  if (window.ScrollTrigger) ScrollTrigger.refresh();
});

function setupFooterCardRotation(reduceMotion) {
  if (reduceMotion || !window.gsap || !window.ScrollTrigger) return;
  const card = document.getElementById("footer-card");
  const footer = document.getElementById("site-footer");
  if (!card || !footer) return;

  const targetRotation = window.innerWidth > 768 ? 2.71 : 1;

  gsap.fromTo(
    card,
    { rotation: 0 },
    {
      rotation: targetRotation,
      ease: "none",
      scrollTrigger: {
        trigger: footer,
        scroller: getArcanistScroller(),
        start: () => footer.getBoundingClientRect().top + getArcanistScrollTop() - window.innerHeight,
        end: () => footer.getBoundingClientRect().top + getArcanistScrollTop(),
        scrub: true,
        invalidateOnRefresh: true,
      },
    }
  );
}

function setupMobileNav() {
  const toggle = document.getElementById("nav-toggle");
  const panel = document.getElementById("mobile-nav");
  if (!toggle || !panel) return;

  const iconOpen = document.getElementById("nav-toggle-open");
  const iconClose = document.getElementById("nav-toggle-close");

  function setOpen(open) {
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    panel.classList.toggle("arcanist-nav-panel--open", open);
    if (iconOpen) iconOpen.classList.toggle("arcanist-nav-icon--hidden", open);
    if (iconClose) iconClose.classList.toggle("arcanist-nav-icon--hidden", !open);
  }

  toggle.addEventListener("click", () => {
    setOpen(toggle.getAttribute("aria-expanded") !== "true");
  });

  panel.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setOpen(false));
  });

  window.matchMedia("(min-width: 640px)").addEventListener("change", (e) => {
    if (e.matches) setOpen(false);
  });
}

function setupSmoothScroll() {
  if (!window.Lenis) return;

  var pageWrapper = getArcanistScrollContainer();
  var lenisOptions = pageWrapper
    ? {
        wrapper: pageWrapper,
        content: pageWrapper,
        eventsTarget: pageWrapper,
      }
    : {};

  var lenis = new Lenis(lenisOptions);
  window.ArcanistLenis = lenis;

  if (window.ScrollTrigger) {
    var scroller = getArcanistScroller();

    ScrollTrigger.scrollerProxy(scroller, {
      scrollTop: function (value) {
        if (arguments.length) {
          lenis.scrollTo(value, { immediate: true });
        }
        return lenis.scroll;
      },
      getBoundingClientRect: function () {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight,
        };
      },
      pinType: pageWrapper ? "transform" : "fixed",
    });

    ScrollTrigger.defaults({ scroller: scroller });
    lenis.on("scroll", ScrollTrigger.update);
  }

  if (window.gsap) {
    gsap.ticker.add(function (time) {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  }

  window.matchMedia("(min-width: " + ARCANIST_SCROLL_BREAKPOINT + "px)").addEventListener("change", function () {
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });
}

document.addEventListener("shopify:section:load", () => {
  if (window.ScrollTrigger) ScrollTrigger.refresh();
});
